import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cai",
  "use": "icon-cai-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-cai\"><defs><style type=\"text/css\"></style></defs><path d=\"M339.2 64H217.6c-70.4 0-70.4 57.6-70.4 76.8V576c0 38.4 25.6 64 64 64h128V576h-128V128h128V64z\" fill=\"\" p-id=\"1417\" /><path d=\"M857.6 147.2l89.6 371.2c6.4 25.6 0 64-19.2 89.6-19.2 25.6-44.8 38.4-70.4 38.4H588.8s6.4 6.4 6.4 12.8c51.2 76.8 57.6 153.6 12.8 230.4-19.2 32-57.6 70.4-102.4 70.4-83.2 0-89.6-83.2-89.6-108.8v-12.8c-6.4-51.2-12.8-108.8-44.8-153.6-25.6-44.8-44.8-44.8-64-44.8h-32V64h480c44.8 0 89.6 44.8 102.4 83.2zM339.2 582.4c32 6.4 57.6 32 83.2 70.4 38.4 57.6 44.8 121.6 51.2 179.2v12.8c0 44.8 12.8 44.8 25.6 44.8 6.4 0 32-19.2 44.8-38.4 32-51.2 32-108.8-6.4-166.4-12.8-19.2-32-51.2-19.2-83.2 0-6.4 12.8-19.2 44.8-25.6h288c12.8 0 19.2-6.4 19.2-12.8 6.4-6.4 6.4-25.6 6.4-32l-89.6-371.2c0-6.4-19.2-32-32-32H339.2v454.4z\" fill=\"\" p-id=\"1418\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cai.svg
// module id = w2Ze
// module chunks = 76